import { StateInterface } from 'client/Interfaces/StateInterface'
import { createSelector } from 'reselect'

// typescript
import { subscriptionManagementSelector } from './'

// selectors

export const subscriptionAvailablePlansSelector = createSelector<
  StateInterface,
  StateInterface['subscriptionManagement'],
  StateInterface['subscriptionManagement']['availablePlans']
>(subscriptionManagementSelector, (subscriptionManagement) => subscriptionManagement.availablePlans)
